import { render, staticRenderFns } from "./importProjectForm.vue?vue&type=template&id=66ebe6a6"
import script from "./importProjectForm.vue?vue&type=script&lang=js"
export * from "./importProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports